import React from 'react';
import { IconProps } from './types';

const PTPDetailsIcon: React.FC<IconProps> = props => {
  const { size = '32', className, fillColor = '#FCC275' } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
    >
      <rect width={size} height={size} rx="4" fill={fillColor} />
      <path d="M10.4399 5.99988L10.4399 22.8799H21.5599V5.99988H10.4399Z" fill="white" />
      <path
        d="M12.6602 10.6899H19.3302"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M12.6602 12.8999H19.3302"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M14.8702 10.6899C16.0902 10.6899 17.0702 11.6799 17.0702 12.8899C17.0702 14.0999 16.0802 15.0899 14.8702 15.0899C14.5502 15.0899 14.2402 15.0199 13.9702 14.8899L17.2602 18.1799"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M25.3801 21.4302V24.3902C25.3801 24.9402 24.9301 25.3902 24.3801 25.3902H7.62012C7.07012 25.3902 6.62012 24.9402 6.62012 24.3902V21.4302"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PTPDetailsIcon;
